const initialState = {
    car_plan: JSON.parse(localStorage.getItem('car_plan')) || null,
};

const carPlanReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CAR_PLAN':
            localStorage.setItem('car_plan', JSON.stringify(action.payload));
            return {
                ...state,
                car_plan: action.payload,
            };
        default:
            return state;
    }
};

export default carPlanReducer;